module.exports = __webpack_public_path__ + "img/fondo_arboles.6b57b795.jpg";